module.exports = __webpack_public_path__ + "img/newyear-2024.4bab0b14.jpg";